import { Box, Typography } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EanField from "./EanField";

const ProductsList = ({ 
  invoiceData, 
  showEanField, 
  eanInputs, 
  onEanInputChange, 
  eanValidated, 
  eanRefs, 
  onEanKeyDown 
}) => {
  const getProducts = () => {
    if (invoiceData.shipping?.items_gtin?.length > 0) {
      return invoiceData.shipping.items_gtin;
    }
    
    if (invoiceData.content?.products?.length > 0) {
      return invoiceData.content.products.map((product, idx) => ({
        item_title: product.name || product.item_title || `Produto ${idx + 1}`,
        gtin_code: product.gtin_code || null,
      }));
    }
    
    if (invoiceData.content?.item_title) {
      return [{
        item_title: invoiceData.content.item_title,
        gtin_code: invoiceData.content.gtin_code || null,
      }];
    }
    
    return [{
      item_title: "Produto",
      gtin_code: null,
    }];
  };

  const products = getProducts();

  if (products.length === 0) {
    return (
      <Typography
        variant="body2"
        color="warning.main"
        sx={{ fontWeight: 600, color: "#ff9800" }}
      >
        Nenhum produto encontrado.
      </Typography>
    );
  }

  return (
    <>
      {products.map((item, idx) => (
        <Box
          key={item.gtin_code || idx}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              flex: 3,
              minWidth: 180,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <ShoppingCartIcon sx={{ color: "#ff9800", mr: 1 }} />
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "#333",
                fontSize: { xs: "1rem", md: "1.1rem" },
              }}
            >
              {item.item_title || `Produto ${idx + 1}`}
            </Typography>
          </Box>
          
          <EanField
            item={item}
            idx={idx}
            showEanField={showEanField}
            eanInputs={eanInputs}
            onEanInputChange={onEanInputChange}
            eanValidated={eanValidated}
            eanRefs={eanRefs}
            onEanKeyDown={onEanKeyDown}
          />
        </Box>
      ))}
    </>
  );
};

export default ProductsList;